export default __webpack_public_path__ + "static/media/FONDOB.bfaba52a.jpg";